module.exports = __webpack_public_path__ + "static/media/UGoing_Logo_w_final.4b8d5b74.png";